// eslint-disable-next-line
export default new (class SliderModel {
  // static API_URL = process.env.REACT_APP_API_URL;

  async get(data) {
    const model = {};

    model.id = data.id || 0;
    model.title = data.title || "";
    model.image =
      data.image?.image?.[0]?.formats?.large?.url ||
      data.image?.image?.[0]?.url ||
      "";

    return model;
  }
})();
